import { PLCustomerData } from 'types/plCustomerData';

import type { Store } from '../../types';

import { carContractValidator } from './carContractValidator';

export const requiredCustomerInformation = (customer: Partial<PLCustomerData>): boolean => {
	if (!customer) return false;
	const {
		city,
		birthdate,
		email,
		lastName,
		initials,
		gender,
		houseNumber,
		postalCode,
		street,
		phoneNumber,
		extraInformation,
	} = customer;

	if (
		!city ||
		!houseNumber ||
		!(email || extraInformation?.email) ||
		!initials ||
		!postalCode ||
		!gender ||
		!street ||
		!lastName ||
		!(birthdate || extraInformation?.birthdate) ||
		!(phoneNumber || extraInformation?.phoneNumber)
	) {
		return false;
	}
	return true;
};

export const overviewValidator = (state: Store): boolean => {
	if (!carContractValidator(state)) return false;
	if (!requiredCustomerInformation(state.plCustomer)) return false;
	return true;
};
